module.exports = __webpack_public_path__ + "img/plus-icon.1aa9a3f1.svg";